import { Info, Lightbulb, AlertTriangle, ShieldCheck } from "lucide-react";

const VARIANTS = {
  note: {
    icon: Info,
    container: "border-info/30 bg-info/5",
    iconColor: "text-info",
    label: "Note",
  },
  tip: {
    icon: Lightbulb,
    container: "border-primary/30 bg-primary/5",
    iconColor: "text-primary",
    label: "Tip",
  },
  warning: {
    icon: AlertTriangle,
    container: "border-warning/40 bg-warning/10",
    iconColor: "text-warning",
    label: "Heads up",
  },
  privacy: {
    icon: ShieldCheck,
    container: "border-accent/30 bg-accent/5",
    iconColor: "text-accent",
    label: "Privacy",
  },
};

/**
 * Inline callout box used inside articles. Variants change the
 * accent color and default label.
 *
 * Props:
 *   - variant: "note" | "tip" | "warning" | "privacy" (default "note")
 *   - title: optional heading; falls back to the variant's label
 *   - children: body
 */
export default function Callout({ variant = "note", title, children }) {
  const v = VARIANTS[variant] || VARIANTS.note;
  const Icon = v.icon;
  return (
    <div className={`rounded-xl border ${v.container} px-4 py-3 flex gap-3`}>
      <Icon className={`h-5 w-5 shrink-0 mt-0.5 ${v.iconColor}`} />
      <div className="space-y-1 text-sm leading-relaxed">
        <p className="font-semibold text-foreground">{title || v.label}</p>
        <div className="text-muted-foreground space-y-2 [&_strong]:text-foreground [&_a]:text-primary [&_a:hover]:underline">
          {children}
        </div>
      </div>
    </div>
  );
}
